var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-page",staticStyle:{"margin":"0px","padding":".5in","width":"8.5in","height":"10.5in","clear":"both","page-break-before":"always","font-family":"'SF Pro Display', 'Open Sans', Arial, sans-serif","background-color":"white","color":"black"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }